/*** IMPORTS FROM imports-loader ***/
var define = false;

export default () => {
  let sAgent = window.navigator.userAgent;
  let Idx = sAgent.indexOf("MSIE");
  if (Idx > 0) {
    return false;
  }

  if (navigator.userAgent.match(/Trident\/7\./)) {
    return true;
  }

  return false;
}

